import {CheckInFormValues, validateRequiredTrailerNumber, validateRequiredSealNumber, validateRequiredDriverFirstName, validateRequiredDriverLastName, validateRequiredDriverLicenseNumber, validateOptionalScacCode} from '../../util/check-in-field-validation';

/**
 * Validates the default fields for Trailer Loaded check-in.
 * Covers: TRUCK_TRAILER_LOADED, TRAILER_LOADED, REEFER_LOADED_PLUGIN,
 *         REEFER_LOADED_NO_PLUGIN, TRUCK_REEFER_LOADED_PLUGIN, TRUCK_REEFER_LOADED_NO_PLUGIN.
 * Required: trailerNumber, sealNumber, driverFirstName, driverLastName, driverLicenseNumber.
 */
export const validateTrailerLoadedForm = (values: CheckInFormValues): string | undefined =>
  validateRequiredTrailerNumber(values.trailerNumber) ??
  validateRequiredSealNumber(values.sealNumber) ??
  validateRequiredDriverFirstName(values.driverFirstName) ??
  validateRequiredDriverLastName(values.driverLastName) ??
  validateRequiredDriverLicenseNumber(values.driverLicenseNumber) ??
  validateOptionalScacCode(values.scacCode);
